export const formatSearch = (value: string) => {
  const formatedSearch = value.replace(/\.|-/g, '');
  return formatedSearch;
};
